<template>
  <div class="lg:mt-10 md:mt-9 mt-5 gap-4">
    <div class="container">
      <div class="lg:w-2/3">
        <h2 class="text4F0A4B font-semibold fsize24 sm-fsize16 mb-2">
          Symptoms of Neurological Disorders
        </h2>
        <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
          The symptoms of neurological disorders can vary widely depending on
          the specific disorder and the part of the nervous system that is
          affected. Common symptoms of neurological disorders include
        </p>
      </div>
      <div
        class="lg:mt-12 md:mt-10 mt-6 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-8"
      >
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Changes%20in%20vision%20or%20hearing.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Changes in vision or hearing
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Memory%20loss%20or%20confusion.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Memory loss or confusion
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Headaches%20or%20migraines.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Headaches or migraines
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Numbness%20or%20tingling%20in%20the%20hands%20and%20feet.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Numbness or tingling in the hands and feet
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Difficulty%20speaking%20or%20understanding%20language.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Difficulty speaking or understanding language
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/weakness%20or%20paralysis%20in%20the%20limbs.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            weakness or paralysis in the limbs
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Seizures%20or%20convulsions.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Seizures or convulsions
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Changes%20in%20mood%20or%20behaviour.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Changes in mood or behaviour
          </p>
        </div>
        <div class="">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20neurodegenerative%20page/Difficulty%20with%20coordination%20or%20balance.jpg"
            alt="sign"
            class="sign_img mx-auto object-cover"
          />
          <p
            class="text-dark pt-2 md-fsize14 fsize16 font-semibold text-center uppercase"
          >
            Difficulty with coordination or balance
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-4/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
    <div class="mb-4 mt-8">
      <h3 class="fsize24 text-primary font-semibold mb-2">
        Causes of Neurological Disorders
      </h3>
      <p class="fsize16 text-dark font-medium">
        The exact causes of neurological disorders are not known. However,
        researchers believe that a combination of genetic and environmental
        factors may play a role. Some risk factors for developing these
        disorders include:
      </p>
      <li class="fsize16">Age</li>
      <br />
      <li class="fsize16">Family history</li>
      <br />
      <li class="fsize16">Exposure to toxins</li>
      <br />
      <li class="fsize16">Head injuries</li>
      <br />
      <li class="fsize16">Poor diet and nutrition</li>
      <br />
      <li class="fsize16">Lack of physical activity</li>
      <br />
      <li class="fsize16">Chronic stress and anxiety</li>
      <br />
    </div>
  </div>
</template>
<script>
import SideBlogs from "../components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
